import Vue from "vue";
import packageJson from "@/../package.json";
import DeviceInfo from "@/modules/DeviceManager.js";

const _getServerConfigs = (env = "dev") => {
  const _DefaultProd = {
    serverId: "_Default(cloud)",
    name: "Default (cloud)",
    about: "https://pos-engine.digitory.com",
    url: "https://pos-engine.digitory.com/",
    wsUrl: "wss://pos-engine.digitory.com",
    ip: null,
    port: null,
    ssl: true,
    editIP: false,
  };
  const _DefaultLocal = {
    serverId: "_Default(local)",
    name: "Default (local)",
    about: "digipos.local",
    url: "http://digipos.local:8000/",
    wsUrl: "ws://digipos.local:8000",
    ip: null,
    port: "8000",
    ssl: false,
    editIP: false,
  };
  /* const _DefaultLocal0 = {
    serverId: "_Default(local 0)",
    name: "Default (local 0)",
    about: "192.168.0.10",
    url: "http://192.168.0.10:8000/",
    wsUrl: "ws://192.168.0.10:8000",
    ip: "192.168.0.10",
    port: "8000",
    ssl: false,
    editIP: false,
  };
  const _DefaultLocal1 = {
    serverId: "_Default(local 1)",
    name: "Default (local 1)",
    about: "192.168.1.10",
    url: "http://192.168.1.10:8000/",
    wsUrl: "ws://192.168.1.10:8000",
    ip: "192.168.1.10",
    port: "8000",
    ssl: false,
    editIP: false,
  };*/

  const _Manual = {
    serverId: "_Manual",
    name: "— MANUAL IP  —",
    about: "",
    url: "http://192.168.0.250:8000/",
    wsUrl: "ws://192.168.0.250:8000",
    ip: "192.168.0.250",
    port: "8000",
    ssl: false,
    editIP: true,
  };
  const _DefaultDev = {
    serverId: "_Default(local)",
    name: "Default (local)",
    about: "127.0.0.1",
    url: "http://127.0.0.1:8000/",
    wsUrl: "ws://127.0.0.1:8000",
    ip: "127.0.0.1",
    port: "8000",
    ssl: false,
    editIP: false,
  };
  const _DefaultStaging = {
    serverId: "_Default(staging)",
    name: "Default (staging)",
    about: "https://staging-pos-engine.digitory.com",
    url: "https://staging-pos-engine.digitory.com/",
    wsUrl: "wss://staging-pos-engine.digitory.com",
    ip: null,
    port: null,
    ssl: true,
    editIP: false,
  };
  const _DevStaging = {
    serverId: "_Dev(staging)",
    name: "Dev (staging)",
    about: "https://dev.digitory.com/pos-engine",
    url: "https://dev.digitory.com/pos-engine/",
    wsUrl: "wss://dev.digitory.com/pos-engine",
    ip: null,
    port: null,
    ssl: true,
    editIP: false,
  };

  return {
    prod: {
      ..._DefaultProd,
      allowedServers: [
        _DefaultProd,
        _DefaultLocal,
        // _DefaultLocal0,
        // _DefaultLocal1,
        _Manual,
      ],
    },
    staging: {
      ..._DefaultStaging,
      allowedServers: [_DefaultStaging, _DevStaging],
    },
    dev: {
      ..._DefaultDev,
      allowedServers: [_DefaultStaging, _DefaultDev, _Manual],
    },
  }[env];
};
// staging 139.59.44.82
export const globalData = new Vue({
  data: (() => {
    const _getEnvCfg = (env = "dev") => {
      return {
        prod: {
          appMode: 2,
          appName: "prod-kds",
          appCode: "cb6067211cc049efaaeba0c851eecd9d",
          ..._getServerConfigs("prod"),
        },
        staging: {
          appMode: 1,
          appName: "staging-kds",
          appCode: "9ff897d49cb7493cadf1b9a04425f390",
          ..._getServerConfigs("staging"),
        },
        dev: {
          appMode: 1,
          appName: "staging-kds",
          appCode: "9ff897d49cb7493cadf1b9a04425f390",
          ..._getServerConfigs("dev"),
        },
      }[env];
    };

    const env = _getEnvCfg(process.env.VUE_APP_MODE);

    const _getSelectedServerConfig = () => {
      let selectedServer = data.$allowedServers.find(
        (obj) => obj.serverId === data.$serverId
      );
      // fallback
      if (!selectedServer) {
        selectedServer = data.$allowedServers[0];
      }
      let serverConfig = JSON.parse(JSON.stringify(selectedServer));
      serverConfig.ip = data.$engineIP;
      return serverConfig;
    };

    const _getUrls = (serverId, newIp) => {
      // find server config
      let serverConfig = data.$allowedServers.find(
        (obj) => obj.serverId === serverId
      );
      // fallback
      if (!serverConfig) {
        serverConfig = data.$allowedServers[0];
      }

      let cfg = { url: env.url, wsUrl: env.wsUrl, port: serverConfig.port };
      let protocol = "http";
      let wsProtocol = "ws";

      if (!serverConfig.editIP) {
        cfg.url = serverConfig.url;
        cfg.wsUrl = serverConfig.wsUrl;
        cfg.ip = serverConfig.ip;
        return cfg;
      }

      cfg.url = `${protocol}://${newIp}:${serverConfig.port}/`;
      cfg.wsUrl = `${wsProtocol}://${newIp}:${serverConfig.port}`;
      cfg.ip = newIp;
      return cfg;
    };

    const _resetUrl = (serverId, newIp) => {
      let { url, wsUrl, ip, port } = _getUrls(serverId, newIp);
      data.$serverId = serverId;
      data.$engineIP = ip;
      data.$enginePort = port;
      data.$url = url;
      data.$wsUrl = wsUrl;
    };

    const _editConn = (serverId, ip) => {
      // update data
      _resetUrl(serverId, ip);

      // store in storage
      localStorage.setItem(
        "_domain",
        JSON.stringify({
          serverId,
          ip,
        })
      );
    };

    let data = {
      $appVersion: packageJson.version,
      $platform: process.env.VUE_APP_PLATFORM || "web", // ["android", "linux", "win", "mac-os", "ios"]
      $appMode: env.appMode,
      $appName: env.appName,
      $appCode: env.appCode,
      $compiler: process.env.VUE_APP_COMPILER || "browser",
      $editConnection: _editConn,
      $getUrls: _getUrls,
      $getSelectedServerConfig: _getSelectedServerConfig,
      $engineIP: env.ip,
      $enginePort: env.port,
      $ssl: env.ssl,
      $url: env.url,
      $wsUrl: env.wsUrl,
      $allowedServers: env.allowedServers,
      $serverId: env.serverId,
      $deviceId: "",
      $deviceName: "",
      $os: "",
    };

    DeviceInfo(process.env.VUE_APP_RUNTIME, (device_id, device_name, os) => {
      data.$deviceId = device_id;
      data.$deviceName = device_name;
      data.$os = os;
    });

    const d = localStorage.getItem("_domain");
    if (d) {
      const domain = JSON.parse(d);
      _editConn(domain.serverId, domain.ip);
    } else if (localStorage.getItem("nodeId")) {
      // Device was registered under the pre-domain-guard flow — persist the
      // current default so the new guard doesn't force an unnecessary re-setup.
      _editConn(data.$serverId, data.$engineIP);
    }
    return data;
  })(),
});

Vue.mixin({
  computed: {
    $apiURL() {
      return globalData.$data.$url;
    },
  },
});
